import { useGlobalState } from '@libs/client/hooks'
import {
  localIsPayingKey,
  localOrderIdKey,
  localOrderKey,
  localPurchasedOrderKey,
  localShippingAddressKey,
  localSourceEventKey,
  localOtpOutKey,
  localStripePaymentConfirmKey,
  localIsCollectTax,
  localVisitTimeKey,
  lastPLabelItem,
  completeCard
} from '@libs/client/helpers'
import { useRouter } from 'next/router'
import { CustomerAddress } from '../services'
import { useMemo } from 'react'

export const useLocalOrderId = () => {
  const [orderId, setOrderId] = useGlobalState<string | null>(localOrderIdKey())
  return [orderId, setOrderId] as const
}

export const useLocalOrder = <T extends SfTypes.Order>() => {
  const [order, setOrder] = useGlobalState<T | null>(localOrderKey)
  return [order, setOrder] as const
}

export const useLocalPurchasedOrder = <T extends SfTypes.Order>() => {
  const [order, setOrder] = useGlobalState<T | null>(localPurchasedOrderKey())
  return [order, setOrder] as const
}

export const useIsOrderPaying = () => {
  const [isPaying, setIsPaying] = useGlobalState<boolean | null>(localIsPayingKey())
  return [isPaying, setIsPaying] as const
}

export const useDiscountCode = () => {
  const router = useRouter()
  return useMemo(() => router.query.discount?.toString() || '', [router.query.discount])
}

export const useLocalShippingAddress = (initialValue?: CustomerAddress) => {
  const [localShipping, setLocalShipping] = useGlobalState<CustomerAddress | null>(
    localShippingAddressKey,
    {
      initialValue: initialValue || null
    }
  )
  return [localShipping, setLocalShipping] as const
}

export const useLastPLabelItem = () => {
  const [lastOrderItem, setLastOrderItem] = useGlobalState<string>(lastPLabelItem)
  return [lastOrderItem, setLastOrderItem] as const
}

export const useLocalSourceEvent = () => {
  const router = useRouter()
  const slug = router.query.subpath?.toString()
  const [localSourceEvent, setLocalSourceEvent] = useGlobalState<SfTypes.SourceEvent | null>(
    localSourceEventKey(slug)
  )
  return [localSourceEvent, setLocalSourceEvent] as const
}

export const useStripeConfirm = <T extends SfTypes.StripeConfirm>() => {
  const router = useRouter()
  const slug = router.query.subpath?.toString()
  const [stripeConfirm, setStripeConfirm] = useGlobalState<T | null>(
    localStripePaymentConfirmKey(slug)
  )
  return [stripeConfirm, setStripeConfirm] as const
}
export const useOtpOut = () => {
  const [otpOut, setOtpOut] = useGlobalState<boolean | null>(localOtpOutKey())
  return [otpOut, setOtpOut] as const
}
export const useIsCollectTax = () => {
  const [isCollect, setIsCollect] = useGlobalState<boolean | null>(localIsCollectTax)
  return [isCollect, setIsCollect] as const
}
export const useIsCompletedCard = () => {
  const [isCompleteCard, setIsCompleteCard] = useGlobalState<boolean | null>(completeCard)
  return [isCompleteCard, setIsCompleteCard] as const
}
export const useLocalVisitTime = () => {
  const [localVisitTime, setLocalVisitTime] = useGlobalState<number | null>(localVisitTimeKey)
  return [localVisitTime, setLocalVisitTime] as const
}
